import { findDOMNode } from 'react-dom';

export const findDomElement = (elm) => {
  return (findDOMNode(elm) as Element);
};